import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { getCurrentEnv } from './configs/dbConfigs';

import './index.scss';
import * as serviceWorker from './serviceWorker';
import { Layout } from "./utility/context/Layout"
import store from './stores';
import App from './App';
import Firebase, { FirebaseContext } from './services/Firebase';
import FirebaseService from './services/impl/firebase/FirebaseService';

ReactDOM.render(
  <Provider {...store}>
    <FirebaseContext.Provider value={FirebaseService.getInstance()}>
        <div style={{width: 100+'%', height: 20+'px', background: 'yellow', textAlign: 'center'}}>Environment: {getCurrentEnv()}</div>
        <App />
    </FirebaseContext.Provider>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
